<template>
  <div>
    <form class="needs-validation" @submit.prevent="submitted">

      <div ref="myTextarea" class="form-group">
        <label for="ppData">Полные данные платежек, входящих в пакет</label>
        <textarea readonly
            id="ppData"
            v-model="areaContent"
            rows="20"
            cols="100"
            class="form-control form-control-sm"
        />
      </div>

      <div @click="copyToClipboard" class="btn btn-sm btn-secondary">
        <i class="fas fa-ticket"></i> Скопировать в буфер
      </div>
      <p v-if="copyStatus">{{ copyStatus }}</p>

    </form>
  </div>
</template>

<script>

import { renderPaymentOrderPackageHeaderForSber } from './partner_utils.js';
import { renderOnePaymentOrderBodyForSber } from './partner_utils.js';
import { renderOnePaymentOrderFooterUniversal } from './partner_utils.js';


export default {

  name: "ViewPartnerProfitOrderPackage",
  data() {
    return {
      areaContent: null,
      copyStatus: '',
      packageData: null,
      ppDataObjects: [
        {
          payer_current_account: null,
          number: null,
          date: null,
          sum: null,
          payer_inn: null,
          payer_name: null,
          payer_bank_name: null,
          payer_bank_city: null,
          payer_bank_bic: null,
          payer_bank_corr_account: null,
          recipient_current_account: null,
          recipient_inn: null,
          recipient_kpp: null,
          recipient_name: null,
          recipient_bank_name: null,
          recipient_bank_bic: null,
          recipient_bank_city: null,
          recipient_bank_corr_account: null,
          reason: null,
          reason_suffix: null,
          reason_suffix2: null,
        },
      ],
      submitted: false,
    }
  },
  mounted() {
  },
  props: {
  },
  watch: {
  },
  computed: {
  },
  validations: {
  },
  methods: {
    generateAreaContent() {
      let result = renderPaymentOrderPackageHeaderForSber(this.ppDataObjects[0], this.packageData) + `\n`;
      for (const dataObject of this.ppDataObjects) {
        result += renderOnePaymentOrderBodyForSber(dataObject) + `\n`;
      }
      result += renderOnePaymentOrderFooterUniversal();
      this.areaContent = result;
    },
    setNullFormData() {
      this.areaContent = null;
      this.copyStatus = '';
      this.packageData = null;
      this.ppDataObjects = [
        {
          payer_current_account: null,
          number: null,
          date: null,
          sum: null,
          payer_inn: null,
          payer_name: null,
          payer_bank_name: null,
          payer_bank_city: null,
          payer_bank_bic: null,
          payer_bank_corr_account: null,
          recipient_current_account: null,
          recipient_inn: null,
          recipient_kpp: null,
          recipient_name: null,
          recipient_bank_name: null,
          recipient_bank_bic: null,
          recipient_bank_city: null,
          recipient_bank_corr_account: null,
          reason: null,
          reason_suffix: null,
          reason_suffix2: null,
        },
      ];
    },
    async copyToClipboard() {
      try {
        // Использование Clipboard API
        await navigator.clipboard.writeText(this.areaContent);
        this.copyStatus = 'Текст скопирован!';
      } catch (err) {
        this.copyStatus = 'Ошибка при копировании';
        console.error('Ошибка:', err);
      }
    }
  },
};
</script>

<style scoped lang="css">

</style>
